var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "custom-navbar",
      class: _vm.styles,
      attrs: { role: "navigation" },
    },
    [
      _c("div", { staticClass: "left-pad padding" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "custom-navbar-items", attrs: { role: "list" } },
        _vm._l(_vm.items, function (item) {
          return _c("NavbarItem", { key: item.name, attrs: { item: item } })
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right-pad padding" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }